import Dashboard from 'components/Layout/Dashboard/Dashboard';
import SettingsComponent from 'components/Settings/Settings';
import React, { useEffect, useState } from 'react';
import selectors from 'store/selectors';
import { connect } from 'react-redux';
import { Loader } from 'components/Base';

const SettingsPage = ({ isFirmAdmin }: any) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isFirmAdmin !== undefined) {
      setIsLoading(false);
    }
  }, [isFirmAdmin]);

  return (
    <Dashboard>
      <Loader isLoading={isLoading}>
        <SettingsComponent isFirmAdmin={isFirmAdmin} />
      </Loader>
    </Dashboard>
  );
};

export default connect(
  (state: any) => ({
    isFirmAdmin: selectors.advisorSelectors.isFirmAdmin(state)
  }),
  null
)(SettingsPage);
